import { Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import ChipCell from './ChipCell'
import ParentCellOrFragment from './ParentCellOrFragment'
import type { Invitation, User } from '@app/src/types/resourceExplorer'
import { isAdminRole } from '@app/src/utils/rolePermissions'

export type OwnerRestrictionCellProps = {
  user: User | Invitation
}

const OwnerRestrictionCell: React.FC<OwnerRestrictionCellProps> = ({ user }) => {
  const { formatMessage } = useIntl()

  return (
    <ParentCellOrFragment>
      {isAdminRole(user.role) ? (
        <Typography variant="body1" color="text.disabled">
          {formatMessage({ id: 'general.notApplicable' })}
        </Typography>
      ) : (
        <ChipCell
          value={formatMessage({ id: user.isOwnerRestricted ? 'general.yes' : 'general.no' })}
          disableCell
          size="small"
          color={user.isOwnerRestricted ? 'primary' : 'default'}
        />
      )}
    </ParentCellOrFragment>
  )
}

export default OwnerRestrictionCell
